//example https://medium.com/@vergil333/google-analytics-4-in-react-a250005c2455
import ReactGA from "react-ga4";

const logout = () => ReactGA.event('Log Out')
const genLegKit = () => ReactGA.event('Generate Legacy Kit')

//Custom Events
const test = (mocked: boolean) => ReactGA.event({
    action:"Button CLick",
    category:"test",
    label: mocked ? "mocked" : "real"
})

export const gaEvents = {
    eventLogOut: logout,
    pTest:(mocked: boolean) => test(mocked),
    legacyKit: genLegKit
}

